<template>
    <div class="login-wrap">
        <div class="login_box">
            <div class="title">
               个人密码修改
            </div>
              <el-form :model="param" :rules="rules" ref="param" label-width="80px">
                <el-form-item label="原始密码" prop="oldpassword">
                    <el-input  v-model="param.oldpassword"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="newpassword" style="margin-top:30px;">
                    <el-input type="password" v-model="param.newpassword"    show-word-limit minlength="6" maxlength="12"  @input="newInput"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="renewpassword" style="margin-top:30px;">
                    <el-input type="password" v-model="param.renewpassword"    show-word-limit minlength="6" maxlength="12"  @input="sureInput"></el-input>
                </el-form-item>
            </el-form>
            <p class="tip">温馨提示：密码最小长度6个字符,最大长度12个字符,必须包含“数字”和“字母”</p>
            <div class="btn">
                <el-button type="primary" @click="editPwdFn('param')">保存</el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return {
             param: {
                oldpassword: '',
                newpassword: '',
                renewpassword:'',
            },
             rules: {
                oldpassword: [{ required: true, message: '请输入原始密码', trigger: 'blur' }],
                newpassword: [{ required: true, message: '请输入新密码', trigger: 'blur'}],
                renewpassword: [{ required: true, message: '请输入确认密码', trigger: 'blur' }]
            }
        };
    },
    methods: {
        //输入框的值
        newInput(val){
            this.param.newpassword=val;
            if(this.param.newpassword.length>=12){
                this.$message({
                        showClose: true,
                        message: '新密码已到最大长度！！！',
                        type: 'error'
                        });
                        return;
            }
        },
        sureInput(val){
            this.param.renewpassword=val;
            if(this.param.renewpassword.length>=12){
                this.$message({
                        showClose: true,
                        message: '确认密码已到最大长度！！！',
                        type: 'error'
                        });
                        return;
            }
        },
        editPwdFn(formName){
             this.$refs[formName].validate((valid) => {
                if (valid) {
                    let that=this;
                    let regular=/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/;
                    let news=regular.test(that.param.newpassword);
                    let sure=regular.test(that.param.renewpassword);
                    let url = '/api/ucenter.user/password';
                    let query = that.param;  
                    if(!news){
                        that.$message({
                        showClose: true,
                        message: '新密码格式不正确！！！',
                        type: 'error'
                        });
                        return;
                    }else if(!sure){
                       that.$message({
                        showClose: true,
                        message: '确认密码格式不正确！！！',
                        type: 'error'
                        });
                        return;
                    }
                    else if(that.param.renewpassword!==that.param.newpassword){
                        that.$message({
                        showClose: true,
                        message: '确认密码和新密码不一致！！！',
                        type: 'error'
                        });
                        return;
                    }else{
                        //提交操作
                        that.$post(url, query).then(function(response) {
                        if (response.code == '200') {
                                that.$message({
                                showClose: true,
                                message: response.msg+',请重新登录',
                                type: 'success'
                                });
                                that.$router.push({
                                    path:'/login'
                                })
                        } else {
                            that.$message.error(response.msg);
                            return false;
                        }
                       });
                    }
                } else {
                    return false;
                }
                });
        }
    }
};
</script>

<style scoped>
.login-wrap {
        width: 100%;
        height: 100%;
        background: #ffffff;
        box-sizing: border-box;
        padding: 20px;
        box-sizing: border-box;
        padding: 20px 300px;
        box-sizing: border-box;
        background: #eeeeee;
}
.login_box{
    width: 100%;
    height: 100%;
    background: #ffffff;
    padding: 50px;
    box-sizing: border-box;
}
.login_box .title{
    width: 100%;
    height: 50px;
    font-size: 20px;
    color: #000000;
    font-weight: bold;
}
.login_box .tip{
   color:red;
   font-size:10px;
   text-align: right;
   margin-top: 10px;
}
.btn{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 50px;
}
</style>